<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Sobre mim </h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-3">
      <div class="text-center text-md-left">
        <!-- avatar image -->
        <img src="https://github.com/abelgasque.png" alt="abelgasque.com" class="avatar" />
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-9 triangle-left-md triangle-top-sm">
      <div class="rounded bg-white shadow-dark padding-30">
        <div class="row">
          <div class="col-md-6">
            <!-- about text -->
            <p>
              Desenvolvedor fullstack especializado em .NET, Angular e Node.js, com foco em criar soluções robustas,
              escaláveis e de alto desempenho, aproveitando tecnologias de nuvem para otimização e deploy eficiente.
            </p>
            <div class="mt-3">
              <a href="#" class="btn btn-default" (click)="downloadCV($event)">
                Download CV
              </a>
            </div>
            <div class="spacer-30 d-md-none d-lg-none"></div>
          </div>
          <div class="col-md-6">
            <!-- skill item -->
            <div class="skill-item">
              <div class="skill-info clearfix">
                <h4 class="float-left mb-3 mt-0">Back-End</h4>
                <span class="float-right">95%</span>
              </div>
              <ngb-progressbar type="primary" [value]="95"></ngb-progressbar>
              <div class="spacer-20"></div>
            </div>

            <!-- skill item -->
            <div class="skill-item">
              <div class="skill-info clearfix">
                <h4 class="float-left mb-3 mt-0">Front-End</h4>
                <span class="float-right">70%</span>
              </div>
              <ngb-progressbar type="danger" [value]="70"></ngb-progressbar>
              <div class="spacer-20"></div>
            </div>

            <!-- skill item -->
            <div class="skill-item">
              <div class="skill-info clearfix">
                <h4 class="float-left mb-3 mt-0">Fullstack</h4>
                <span class="float-right">85%</span>
              </div>
              <ngb-progressbar type="warning" [value]="85"></ngb-progressbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- row end -->

  <div class="spacer-70"></div>

  <div class="row">
    <div class="col-md-3 col-sm-6">
      <!-- fact item -->
      <div class="fact-item">
        <!-- Ícone de projetos -->
        <span class="icon"><i class="fas fa-fire"></i></span>
        <div class="details">
          <h3 class="mb-0 mt-0 number">
            <em class="count">{{ repos.length || 0 }}</em>
          </h3>
          <p class="mb-0">Projetos</p>
        </div>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-3 col-sm-6">
      <!-- fact item -->
      <div class="fact-item">
        <span class="icon"><i class="fas fa-tasks"></i></span>
        <div class="details">
          <h3 class="mb-0 mt-0 number">
            <em class="count">
              {{ totalCommits || 0 }}
            </em>
          </h3>
          <p class="mb-0">Atualizações GitHub</p>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6">
      <!-- fact item -->
      <div class="fact-item">
        <span class="icon"><i class="fas fa-graduation-cap"></i></span>
        <div class="details">
          <h3 class="mb-0 mt-0 number"><em class="count">2</em></h3>
          <p class="mb-0">Formações</p>
        </div>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-3 col-sm-6">
      <!-- fact item -->
      <div class="fact-item">
        <span class="icon"><i class="fas fa-briefcase"></i></span>
        <div class="details">
          <h3 class="mb-0 mt-0 number"><em class="count">4</em></h3>
          <p class="mb-0">Experiências</p>
        </div>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>


  </div>
</div>